import LoadingScreen from '../common/LoadingScreen';
import { getAuth } from '../redux/selectors/authSelector';
import { getAuthCookie } from '../utils/helpers/authHelpers';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function UserAuthGuard({ children }) {
    const navigate = useNavigate();

    const { isAuth, } = useSelector(getAuth)
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        if (getAuthCookie()) {
            setChecked(true);
        } else {
            navigate('/');
        }
    }, [isAuth]);

    if (!checked) return <LoadingScreen />
    return children;
}
